










import { Vue, Component } from 'vue-property-decorator';
import MisVisitas from '@/pantallas/SucursalVirtual/MisVisitas/MisVisitas.vue';

@Component({
  components: { MisVisitas },
})
export default class MisVisitasPantalla extends Vue {}
